// extracted by mini-css-extract-plugin
export var orderSummary = "_rp-0";
export var showMoreLessButton = "_rp-1";